import { useEffect, useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const TwoFAPanel = ({ job, onSubmitted }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setElapsed(Math.floor((Date.now() - new Date(job.twofa_requested_at || job.updated_at).getTime()) / 1000)), 1000);
    return () => clearInterval(t);
  }, [job.twofa_requested_at, job.updated_at]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/jobs/${job.id}/2fa`, { code });
      toast.success("Código enviado al bot");
      setCode(""); onSubmitted?.();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const remaining = Math.max(0, 900 - elapsed);
  return (
    <form onSubmit={submit} className="rounded-lg border border-amber-400/40 bg-amber-500/10 p-6 space-y-4 rise" data-testid="twofa-panel">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-md bg-amber-500/20 text-amber-500 grid place-items-center shrink-0"><KeyRound className="h-5 w-5" /></div>
        <div>
          <p className="font-display font-semibold">Downtown pidió un código de verificación</p>
          <p className="text-sm text-muted-foreground">Revisa tu correo y pega aquí el código. El bot esperará <span className="font-mono">{Math.floor(remaining / 60)}:{String(remaining % 60).padStart(2, "0")}</span>.</p>
        </div>
      </div>
      <div className="flex gap-2">
        <Input value={code} onChange={(e) => setCode(e.target.value.replace(/\s/g, ""))} placeholder="123456" inputMode="numeric" autoFocus className="font-mono text-lg tracking-[0.3em] h-12" data-testid="input-2fa-code" />
        <Button type="submit" disabled={busy || code.length < 4} className="h-12 gap-2" data-testid="btn-submit-2fa-code"><ShieldCheck className="h-4 w-4" /> Enviar</Button>
      </div>
    </form>
  );
};
